import { render, staticRenderFns } from "./StatsProductAccess.vue?vue&type=template&id=5ebd8b69&"
import script from "./StatsProductAccess.vue?vue&type=script&lang=js&"
export * from "./StatsProductAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports